var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.6666V16.6666M11.6667 14.1666H16.6667M5.00004 8.33325H6.66671C7.58718 8.33325 8.33337 7.58706 8.33337 6.66659V4.99992C8.33337 4.07944 7.58718 3.33325 6.66671 3.33325H5.00004C4.07957 3.33325 3.33337 4.07944 3.33337 4.99992V6.66659C3.33337 7.58706 4.07957 8.33325 5.00004 8.33325ZM13.3334 8.33325H15C15.9205 8.33325 16.6667 7.58706 16.6667 6.66659V4.99992C16.6667 4.07944 15.9205 3.33325 15 3.33325H13.3334C12.4129 3.33325 11.6667 4.07944 11.6667 4.99992V6.66659C11.6667 7.58706 12.4129 8.33325 13.3334 8.33325ZM5.00004 16.6666H6.66671C7.58718 16.6666 8.33337 15.9204 8.33337 14.9999V13.3333C8.33337 12.4128 7.58718 11.6666 6.66671 11.6666H5.00004C4.07957 11.6666 3.33337 12.4128 3.33337 13.3333V14.9999C3.33337 15.9204 4.07957 16.6666 5.00004 16.6666Z",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboardActive.b58215492858f31e080992eea41576d5.svg";
export { ForwardRef as ReactComponent };